//Api
import request from "@/config/_request";
import qs from "qs";

// 获取轮播图列表
export function getHomepage() {
  return request({
    url: "/api/get/homepage",
    method: "get"
  });
}


// 上传轮播图
export function uploadImages(params) {
  return request({
    url: "/api/addOrUpdate/homepageBanner",
    data: qs.stringify(params),
    method: "post"
  });
}

// 修改轮播图
export function updateImages(params) {
  return request({
    url: "/api/addOrUpdate/homepageBanner",
    data: qs.stringify(params),
    method: "post"
  });
}

// 删除轮播图
export function deleteImages(params) {
  return request({
    url: "/api/delete/homepageBanner",
    data: qs.stringify(params),
    method: "post"
  });
}


// 上传LOGO和联系人图片
export function updateHomepage(params) {
  return request({
    url: "/api/update/homepage",
    data: qs.stringify(params),
    method: "post"
  });
}

//上传课程体系
export function uploadCourse(params) {
  return request({
    url: "/api/addOrUpdate/homepageSystem",
    data: qs.stringify(params),
    method: "post"
  });
}

//更新课程体系
export function updateCourse(params) {
  return request({
    url: "/api/addOrUpdate/homepageSystem",
    data: qs.stringify(params),
    method: "post"
  });
}

//删除课程体系
export function deleteCourse(params) {
  return request({
    url: "/api/delete/homepageSystem",
    data: qs.stringify(params),
    method: "post"
  });
}


//添加教师
export function uploadTeacher(params) {
  return request({
    url: "/api/addOrUpdate/homepageTeacher",
    data: qs.stringify(params),
    method: "post"
  });
}

//更新教师
export function updateTeacher(params) {
  return request({
    url: "/api/addOrUpdate/homepageTeacher",
    data: qs.stringify(params),
    method: "post"
  });
}

//删除教师
export function deleteTeacher(params) {
  return request({
    url: "/api/delete/homepageTeacher",
    data: qs.stringify(params),
    method: "post"
  });
}


//添加新闻
export function uploadNews(params) {
  return request({
    url: "/api/addOrUpdate/homepageNews",
    data: qs.stringify(params),
    method: "post"
  });
}

//更新新闻
export function updateNews(params) {
  return request({
    url: "/api/addOrUpdate/homepageNews",
    data: qs.stringify(params),
    method: "post"
  });
}

//删除新闻
export function deleteNews(params) {
  return request({
    url: "/api/delete/homepageNews",
    data: qs.stringify(params),
    method: "post"
  });
}



//添加好处
export function uploadReasons(params) {
  return request({
    url: "/api/addOrUpdate/homepageWhyLearn",
    data: qs.stringify(params),
    method: "post"
  });
}

//更新好处
export function updateReasons(params) {
  return request({
    url: "/api/addOrUpdate/homepageWhyLearn",
    data: qs.stringify(params),
    method: "post"
  });
}

//删除好处
export function deleteReasons(params) {
  return request({
    url: "/api/delete/homepageWhyLearn",
    data: qs.stringify(params),
    method: "post"
  });
}


//添加照片
export function uploadPhotos(params) {
  return request({
    url: "/api/addOrUpdate/homepageStu",
    data: qs.stringify(params),
    method: "post"
  });
}

//更新照片
export function updatePhotos(params) {
  return request({
    url: "/api/addOrUpdate/homepageStu",
    data: qs.stringify(params),
    method: "post"
  });
}

//删除照片
export function deletePhotos(params) {
  return request({
    url: "/api/delete/homepageStu",
    data: qs.stringify(params),
    method: "post"
  });
}

//添加链接
export function uploadLinks(params) {
  return request({
    url: "/api/addOrUpdate/homepageFooterMatch",
    data: qs.stringify(params),
    method: "post"
  });
}

//更新链接
export function updateLinks(params) {
  return request({
    url: "/api/addOrUpdate/homepageFooterMatch",
    data: qs.stringify(params),
    method: "post"
  });
}

//删除链接
export function deleteLinks(params) {
  return request({
    url: "/api/delete/homepageFooterMatch",
    data: qs.stringify(params),
    method: "post"
  });
}

//根据二级域名
export function getSchoolInfo() {
  return request({
    url: "/api/get/getEducationalInstitution/by/domain",
    method: "get"
  });
}

//重置校区首页
export function resetHomepage(params) {
  return request({
    url: "/api/reset/homepage",
    data: qs.stringify(params),
    method: "post",
  });
}
//修改主题颜色
export function updateSchoolThemeColor(params) {
  return request({
    url: "/api/update/school/theme/color",
    data: qs.stringify(params),
    method: "post",
  });
}
//更新主页师资的排序号
export function updateHomepageTeacherSortNum(params) {
  return request({
    url: "/api/updateHomepageTeacherSortNum",
    data: qs.stringify(params),
    method: "post",
    noLoading: true

  });
}